export default "__VITE_ASSET__BQk4TElJ__"